var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 15L9.99967 12.2042L13.6663 15L12.2913 10.4625L15.958 7.85H11.4663L9.99967 3.08333L8.53301 7.85H4.04134L7.70801 10.4625L6.33301 15ZM9.99967 18.6667C8.73162 18.6667 7.53995 18.426 6.42467 17.9448C5.3094 17.4635 4.33926 16.8104 3.51426 15.9854C2.68926 15.1604 2.03613 14.1903 1.55488 13.075C1.07363 11.9597 0.833008 10.7681 0.833008 9.5C0.833008 8.23194 1.07363 7.04027 1.55488 5.92499C2.03613 4.80972 2.68926 3.83958 3.51426 3.01458C4.33926 2.18958 5.3094 1.53645 6.42467 1.0552C7.53995 0.573953 8.73162 0.333328 9.99967 0.333328C11.2677 0.333328 12.4594 0.573953 13.5747 1.0552C14.69 1.53645 15.6601 2.18958 16.4851 3.01458C17.3101 3.83958 17.9632 4.80972 18.4445 5.92499C18.9257 7.04027 19.1663 8.23194 19.1663 9.5C19.1663 10.7681 18.9257 11.9597 18.4445 13.075C17.9632 14.1903 17.3101 15.1604 16.4851 15.9854C15.6601 16.8104 14.69 17.4635 13.5747 17.9448C12.4594 18.426 11.2677 18.6667 9.99967 18.6667Z",
    fill: "#CD7F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.6dbd59ad4a8c4396056e00e6c2e11815.svg";
export { ForwardRef as ReactComponent };